import { render, staticRenderFns } from "./ModalArgumentario.vue?vue&type=template&id=9bfc4fd8&scoped=true"
import script from "./ModalArgumentario.vue?vue&type=script&lang=js"
export * from "./ModalArgumentario.vue?vue&type=script&lang=js"
import style0 from "./ModalArgumentario.vue?vue&type=style&index=0&id=9bfc4fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfc4fd8",
  null
  
)

export default component.exports